import { createFileRoute } from '@tanstack/react-router'

import { EndorsementRulesDocumentationPage } from '../../../../components/pages/backoffice/platform/platform-documentation/endorsement-rules-documentation-page.tsx'

export const Route = createFileRoute('/bo/documentation/endorsement-rules')({
  component: () => <EndorsementRulesDocumentationPage />,
})
